module.exports = __webpack_public_path__ + "static/img/Six of Cups.27b21c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Six of Cups.jpg
// module id = 1299
// module chunks = 0